module.exports = __webpack_public_path__ + "static/media/help_graph_2.292a8550.png";